export const GET_ACTIVE_LOT_INFO = 'GET_ACTIVE_LOT_INFO';
export const GET_ACTIVE_LOT_INFO_SUCCESS = 'GET_ACTIVE_LOT_INFO_SUCCESS';
export const GET_ACTIVE_LOT_INFO_FAILURE = 'GET_ACTIVE_LOT_INFO_FAILURE';

export const UPDATE_ACTIVE_LOT_DATA = 'UPDATE_ACTIVE_LOT_DATA';
export const CLEAR_ACTIVE_LOT_DATA = 'CLEAR_ACTIVE_LOT_DATA';
